(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
// Delegation keeps the size chart working after variant section updates.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const modal = document.getElementById('sizeChartModal');
    if (!(modal instanceof HTMLDialogElement)) return;
    if (event.target.closest('#openSizeChart, [data-size-chart-open]')) {
      event.preventDefault();
      if (!modal.open) modal.showModal();
      return;
    }
    if (event.target.closest('.size-chart-close')) {
      modal.close();
      return;
    }
    if (event.target === modal) {
      const bounds = modal.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        modal.close();
      }
    }
  });

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-copy-coupon]');
    if (!(button instanceof HTMLButtonElement) || !button.closest('.unbound-product-refresh')) return;
    const offer = button.closest('[data-copy-offer]');
    const input = offer?.querySelector('[data-coupon-code]');
    const status = offer?.querySelector('[data-copy-status]');
    if (!(input instanceof HTMLInputElement) || !status) return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(input.value);
      button.textContent = button.dataset.copied;
      status.textContent = button.dataset.copied;
    } catch {
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      status.textContent = button.dataset.manual;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unbound-collection-promos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unbound-promos')) { customElements.define('unbound-promos', class extends HTMLElement { connectedCallback() { if(this.timer) clearInterval(this.timer); if(!this.ready) { this.ready=true; const track=this.querySelector('.ub-promos__track'); const dots=[...this.querySelectorAll('[data-slide]')]; this.current=0; this.go=index=>{this.current=(index+dots.length)%dots.length;track.scrollTo({left:this.current*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.dataset.slide!==undefined)this.go(Number(button.dataset.slide));if(button.dataset.direction)this.go(this.current+Number(button.dataset.direction));});track.addEventListener('scroll',()=>{this.current=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((dot,index)=>index===this.current?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));},{passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.go(this.current+(event.key==='ArrowRight'?1:-1));}}); } this.timer=setInterval(()=>{if(!document.hidden&&!matchMedia('(prefers-reduced-motion: reduce)').matches)this.go(this.current+1);},8000); } disconnectedCallback(){clearInterval(this.timer);this.timer=null;} }); }

  } catch(e) { console.error(e); }
})();
})();
